class BulkOrderModalController {
    constructor(options = {}) {
        //options
        this.formModalId = options.formModalId || "bulk-order";
        this.successModalId = options.successModalId || "bulk-order-thank-you";
        
        // Initialize CartQf for validation purposes
        this.cartQf = new window.CartQf();

        this.addEventListeners();
    }

    addEventListeners() {
        const closeFormModalButton = document.querySelector(".bulk-order--modal-container .modal .close-button");
        const form = document.querySelector('.bulk-order--modal-container .modal form');
        const asapCheckbox = form.querySelector('input[name="contact[date-occasion-asap]"]');

        // Bind event listeners
        window.addEventListener("cart_changed", e => { 
            this.checkSideCartNotificationDisplayStatus();
        });
        closeFormModalButton.addEventListener('click', e => { this.handleCloseFormModal(e) });
        form.addEventListener('submit', e => { this.handleSubmit(e) });
        
        // Listen for changes in the form fields to trigger validation
        if (asapCheckbox) {
            asapCheckbox.addEventListener('change', e => { 
                this.handleASAPChange(e);
                this.cartQf.validateBulkOrderForm();  // Re-validate on checkbox change
            });
        }

        // Validate on form load and when any field changes
        this.cartQf.validateBulkOrderForm();
        form.addEventListener('change', () => this.cartQf.validateBulkOrderForm());
    }

    handleCloseFormModal(e) {
        e.preventDefault();

        const formErrors = document.querySelector(".bulk-order--modal-container .modal .form-errors");
        if (formErrors) {
            formErrors.style.display = "none";
        }

        window.modalController.hideModal(this.formModalId);
    }

    handleCloseSuccessModal(e) {
        e.preventDefault();
        window.modalController.hideModal(this.successModalId);
    }

    handleASAPChange(e) {
        const dateOfOccasionInput = document.querySelector('.bulk-order--modal-container .modal .form input#date-occasion');
        dateOfOccasionInput.disabled = e.target.checked;

        // Trigger form validation whenever the ASAP checkbox changes
        this.cartQf.validateBulkOrderForm();
    }

    handleSubmit(e) {
        console.log(e);

        e.preventDefault();

        let data = this.serializeForm();
        console.log("handle submit", data);
        window.cart.update({ attributes: data });
        window.modalController.hideModal(this.formModalId);

        // Re-validate the cart form after submission
        this.cartQf.validateBulkOrderForm();
    }

    handleFormErrors(){
        window.modalController.presentModal(this.formModalId);
    }

    handleFormSuccess(){
        window.modalController.presentModal(this.successModalId);
    }

    checkSideCartNotificationDisplayStatus() {
        if (this.getCartB2BItemCount() > 0) {
            if (document.querySelector("#shopify-section-bt-side-cart .cart-details__min-spend")) {
                document.querySelector("#shopify-section-bt-side-cart .cart-details__min-spend").style.display = "none";
            }

            if (document.querySelector("#shopify-section-bt-side-cart .cart-details__delivery-date")) {
                document.querySelector("#shopify-section-bt-side-cart .cart-details__delivery-date").style.display = "block";
            }
        } else {
            if (document.querySelector("#shopify-section-bt-side-cart .cart-details__min-spend")) {
                document.querySelector("#shopify-section-bt-side-cart .cart-details__min-spend").style.display = "block";
            }

            if (document.querySelector("#shopify-section-bt-side-cart .cart-details__delivery-date")) {
                document.querySelector("#shopify-section-bt-side-cart .cart-details__delivery-date").style.display = "none";
            }
        }
    }

    getCartB2BItemCount() {
        return document.querySelectorAll("#shopify-section-bt-side-cart .items .item[data-is-bulk-buy-item]").length;
    }

    serializeForm() {
        var form = document.querySelector("#bulkOrderForm");
        var formInputs = form.querySelectorAll('input, select');
        var formTextareas = form.querySelectorAll('textarea');
        var fieldsObject = {};

        if (formInputs.length) {
            formInputs.forEach(function (input) {
                var name = input.getAttribute('name');
                console.log(name);
                console.log(input.type);
        
                if( input.type === 'select' ){
                    fieldsObject[name] = input.options[input.selectedIndex].text;
                    return;
                }
        
                if (input.type !== 'submit' && input.type !== 'checkbox') {
                    var value = input.value;
                    fieldsObject[name] = value;
                }
            });
        }

        if (formTextareas.length) {
            formTextareas.forEach(function (textarea) {
                var name = textarea.getAttribute('name');
                var value = textarea.value;
                fieldsObject[name] = value;
            });
        }

        return fieldsObject;
    }
}

window.BulkOrderModalController = new BulkOrderModalController();
